class OsirisStickyPurchase extends HTMLElement {
  connectedCallback() {
    this.root = document.getElementById(`MainProduct-${this.dataset.section}`);
    this.primary = this.root?.querySelector('product-form [name="add"]');
    if (!this.primary) return;
    this.media = window.matchMedia('(max-width: 749px)');
    this.action = this.querySelector('[data-osiris-submit]');
    this.handleClick = () => {
      const button = this.root.querySelector('product-form [name="add"]');
      if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
      button.click();
    };
    this.action.addEventListener('click', this.handleClick);
    this.sync = () => {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => {
        const button = this.root.querySelector('product-form [name="add"]');
        const price = this.root.querySelector(`#price-${this.dataset.section} .price__sale .price-item--sale`) || this.root.querySelector(`#price-${this.dataset.section} .price-item--regular`);
        const priceBox = this.root.querySelector(`#price-${this.dataset.section} .price`);
        const currentPrice = priceBox?.classList.contains('price--on-sale') ? price : this.root.querySelector(`#price-${this.dataset.section} .price__regular .price-item--regular`);
        this.querySelector('.osiris-sticky__price').textContent = currentPrice?.textContent.trim() || '';
        const choices = [...this.root.querySelectorAll('variant-selects input:checked, variant-selects select')].map(input => input.tagName === 'SELECT' ? input.selectedOptions[0]?.textContent.trim() : input.value);
        this.querySelector('.osiris-sticky__variant').textContent = choices.filter(Boolean).join(' / ');
        this.action.textContent = button?.querySelector('span')?.textContent.trim() || '';
        this.action.disabled = !button || button.disabled || button.getAttribute('aria-disabled') === 'true';
        this.hidden = !this.media.matches || !this.pastControls || document.body.classList.contains('overflow-hidden') || !!document.querySelector('cart-drawer.active, details[open].menu-opening, dialog[open]');
      });
    };
    this.observer = new IntersectionObserver(([entry]) => {
      this.pastControls = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
      this.sync();
    });
    this.observer.observe(this.primary);
    this.mutations = new MutationObserver(this.sync);
    this.mutations.observe(this.root, {childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'value', 'class']});
    this.bodyObserver = new MutationObserver(this.sync);
    this.bodyObserver.observe(document.body, {attributes: true, attributeFilter: ['class']});
    this.media.addEventListener('change', this.sync);
    this.root.addEventListener('change', this.sync);
    this.sync();
  }
  disconnectedCallback() {
    this.observer?.disconnect();
    this.mutations?.disconnect();
    this.bodyObserver?.disconnect();
    this.media?.removeEventListener('change', this.sync);
    this.root?.removeEventListener('change', this.sync);
    this.action?.removeEventListener('click', this.handleClick);
    cancelAnimationFrame(this.frame);
  }
}
if (!customElements.get('osiris-sticky-purchase')) customElements.define('osiris-sticky-purchase', OsirisStickyPurchase);
